import { css } from "styled-components";

const GlobalBehavior = {
  clickable: css`
    transition: 0.1s all ease-out;
    &:hover {
      filter: brightness(90%);
    }
    &:active {
      opacity: 75%;
    }
  `,
};

export default GlobalBehavior;
